import Cookie from 'js-cookie';
import EventEmitter from 'events';

const emitter = new EventEmitter();
let pendingCreatedPost = null;
let pendingCreatedPostTimer = null;

let PreferenceService = {
    subscribe(event, callback) {
        return emitter.addListener(event, callback);
    },

    unsubscribe(event, callback) {
        return emitter.removeListener(event, callback);
    },

    isExplicitContentFilterSet() {
        return !!Cookie.get('explicitContentFilter');
    },

    getExplicitContentFilter() {
        return (Cookie.get('explicitContentFilter') ? Cookie.get('explicitContentFilter') : 'obscure');
    },

    setExplicitContentFilter(filterSetting) {
        Cookie.set('explicitContentFilter', filterSetting);

        emitter.emit('explicitFilterStateChange', filterSetting);
    },

    notifyPostCreated(post) {
        pendingCreatedPost = post || null;
        if (pendingCreatedPostTimer) clearTimeout(pendingCreatedPostTimer);
        pendingCreatedPostTimer = setTimeout(() => {
            pendingCreatedPost = null;
            pendingCreatedPostTimer = null;
        }, 10000);
        emitter.emit('postCreated', post);
    },

    consumePendingCreatedPost() {
        const p = pendingCreatedPost;
        pendingCreatedPost = null;
        if (pendingCreatedPostTimer) { clearTimeout(pendingCreatedPostTimer); pendingCreatedPostTimer = null; }
        return p;
    },

    shouldFilterAdult() {
        return PreferenceService.getExplicitContentFilter() === 'hide';
    }
};

export default PreferenceService;
